export enum HomeCareLinks {
    InPatientRequest = '/in-patient-request',
    DoctorStation = '/doctor-station',
    transportUnitRequestStation = '/transport-unit-request-station',
    AdmissionStation = '/admission-station',
    TransportationUnits = '/transportation-units',
    OutPatientRequestedSetup = '/out-patient-requested-setup',
    OrderRequestServicesStation = '/order-request-services-station',
}